import { creditRatingScalesMap, scalesTypes } from 'shared/mappings';

export const creditRatingRangeValues = [
  { label: 'D', value: 1 },
  { label: 'C', value: 2 },
  { label: 'CC', value: 3 },
  { label: 'CCC', value: 4 },
  { label: 'B-', value: 5 },
  { label: 'B', value: 6 },
  { label: 'B+', value: 7 },
  { label: 'BB-', value: 8 },
  { label: 'BB', value: 9 },
  { label: 'BB+', value: 10 },
  { label: 'BBB-', value: 11 },
  { label: 'BBB', value: 12 },
  { label: 'BBB+', value: 13 },
  { label: 'A-', value: 14 },
  { label: 'A', value: 15 },
  { label: 'A+', value: 16 },
  { label: 'AA-', value: 17 },
  { label: 'AA', value: 18 },
  { label: 'AA+', value: 19 },
  { label: 'AAA', value: 20 },
];

export const creditRatingLongTermRangeValues = [
  { label: 'S-4', value: 1 },
  { label: 'S-3', value: 2 },
  { label: 'S-2', value: 3 },
  { label: 'S-1', value: 4 },
  { label: 'S-1+', value: 5 },
];

const creditRatingRange = {
  [scalesTypes.rs1]: [...creditRatingRangeValues],
  [scalesTypes.rs2]: [...creditRatingLongTermRangeValues],
  [scalesTypes.rs3]: [...creditRatingRangeValues],
  [scalesTypes.rs4]: [...creditRatingRangeValues],
};

export const creditRatingRangeMapping = (portfolioType, ratingType) =>
  creditRatingRange[creditRatingScalesMap[portfolioType][ratingType]];
